import type SessionService from '@efdigital/ll-addon-auth/services/session';
import {
  type MessagingRole,
  type PartnershipConversation,
  totalUnreadMessageCount,
} from '@efdigital/ll-xceed-v2/utils/coaching/partnership-messages';
import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class PartnershipMessagingService extends Service {
  @service declare session: SessionService;

  @tracked conversations: PartnershipConversation[] = [];
  @tracked role: MessagingRole | null = null;
  @tracked scopeKey: string | null = null;
  /** Bumped whenever message data changes so nav badges re-render. */
  @tracked unreadVersion = 0;

  get unreadCount(): number {
    // Touch unreadVersion so in-place message updates re-render nav badges.
    void this.unreadVersion;

    if (!this.role || !this.conversations.length) {
      return 0;
    }

    return totalUnreadMessageCount(
      this.conversations,
      this.role,
      this.session.cached.userId!
    );
  }

  sync(
    conversations: PartnershipConversation[],
    role: MessagingRole,
    scopeKey: string
  ): void {
    this.conversations = conversations;
    this.role = role;
    this.scopeKey = scopeKey;
    this.unreadVersion++;
  }

  notifyMessagesChanged(): void {
    this.unreadVersion++;
  }

  replaceConversations(conversations: PartnershipConversation[]): void {
    this.conversations = conversations;
  }
}

declare module '@ember/service' {
  interface Registry {
    'partnership-messaging': PartnershipMessagingService;
  }
}
